$(() => {
  const preselected = JSON.parse(localStorage.internalTrainingPreselection ?? '[]')

  $('.internal-training-area ~ .internal-training-choice').hide()
  $('.internal-training-area')
    .addClass('internal-training-accordion')
    .wrapInner('<button type="button" class="internal-training-accordion-toggle"></button>')
    .children()
    .append(
      '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 7.56H0v2.88h18V7.56Z" fill="#0F05A0"/><path class="internal-training-accordion-vertical" d="M7.56 0v18h2.88V0H7.56Z" fill="#0F05A0"/></svg>',
    )
    .on('click', function () {
      const $li = $(this).closest('li')
      $li.toggleClass('open')
      $li.nextUntil('.internal-training-area').slideToggle()
    })

  $('.internal-training-field input[type="checkbox"]').each((index, element) => {
    if (preselected.includes(Number(element.value))) {
      element.checked = true

      $(element)
        .closest('li')
        .prevUntil('.internal-training-area')
        .prev()
        .not('.open')
        .find('button')
        .click()
    }
  })
})
